import Dropdown from '@components/ui/formElements/Dropdown'
import Label from '@components/ui/formElements/Label'
import { SetSelectionArgs } from '@components/ui/formElements/Dropdown/List'
import { AvailableOptions, SelectedOptions } from './types'
import styles from './styles.module.scss'

type BackInStockFormProps = {
  selectedOptions: SelectedOptions
  availableOptions: AvailableOptions
  onSelectFormOptions: (arg: SetSelectionArgs) => void
}

const BackInStockForm = ({
  selectedOptions,
  availableOptions,
  onSelectFormOptions
}: BackInStockFormProps) => {
  return (
    <>
      {availableOptions.map(item => {
        const shouldBeInline = item.id === 'taper' || item.id === 'leg'
        const value = selectedOptions[item.type]
        return (
          <div
            className={`${styles.modalForm__Field} ${
              shouldBeInline ? styles.inline : ''
            }`}
            key={item.id}
          >
            <Label>{item.name}</Label>
            <Dropdown
              defaultValue={String(value)}
              id={item.type}
              list={item.sizes}
              selection={value}
              setSelection={onSelectFormOptions}
            />
          </div>
        )
      })}
    </>
  )
}

export default BackInStockForm
